export default function About() {
  return (
    <section id="about" className="about-section">
      <div className="section-inner about-inner">
        <div className="about-text">
          <p className="section-eyebrow">About</p>
          <h2 className="section-title about-title">
            Who we are
          </h2>
          <p className="about-bio">
            A team of senior engineers and architects with 13+ years shipping enterprise software.
            Heavy AI adopters — and the firm companies call when their AI-built prototype needs to graduate to production.
          </p>
          <p className="about-bio">
            Experienced across fintech, real estate, utilities, and field service industries.
            We have seen the patterns that break systems at scale, and we know how to fix them.
          </p>
          <p className="about-bio about-bio-note">
            10 active certifications across architecture, development &amp; consulting.
          </p>
          <div className="about-links">
            <a href="#contact" className="about-link about-link-cta">
              Get in touch
            </a>
          </div>
        </div>

        <div className="about-certs">
          <p className="certs-title">How we work</p>
          <div className="about-values-grid">
            <div className="about-value-item">
              <span className="about-value-label">AI-first tooling</span>
              <span className="about-value-desc">We invest heavily in AI tools every month — not as a buzzword, but because it lets us ship better code faster than any team our size should.</span>
            </div>
            <div className="about-value-item">
              <span className="about-value-label">Direct communication</span>
              <span className="about-value-desc">You talk to the engineer solving your problem, not an account manager. No ticket queues. No translation layers.</span>
            </div>
            <div className="about-value-item">
              <span className="about-value-label">Production mindset</span>
              <span className="about-value-desc">Everything we build is built to go live, stay live, and be maintainable by the next engineer who touches it.</span>
            </div>
            <div className="about-value-item">
              <span className="about-value-label">Global timezone coverage</span>
              <span className="about-value-desc">Working hours overlap with both US East and West coast. You are not waiting until tomorrow for an answer.</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
